export const profileFields = [
  {
    name: "fullName",
    label: "Full Name",
    type: "text",
    required: true,
    colSpan: {
      base: 6,
      md: 3,
    },
  },
  {
    name: "mobile",
    label: "Mobile Number",
    type: "mobile",
    required: true,
    colSpan: {
      base: 6,
      md: 3,
    },
  },
  {
    name: "email",
    label: "Email",
    type: "email",
      colSpan: {
      base: 6,
      md: 3,
    },
  },
  {
    name: "gender",
    label: "Gender",
    type: "select",
    colSpan: {
      base: 6,
      md: 3,
    },
    options: [
      { value: "male", label: "Male" },
      { value: "female", label: "Female" },
    ],
  },
  {
    name: "dob",
    label: "Date of Birth",
    type: "date",
      colSpan: {
      base: 6,
      md: 3,
    },
  },
  {
    name: "image",
    label: "Image",
    type: "file",
      colSpan: {
      base: 6,
      md: 3,
    },
  },
  {
    name: "address",
    label: "Address",
    type: "textarea",
     colSpan: {
            base: 6,
            sm: 6,
            md: 6,
        },
  },
];
